module.exports = __webpack_public_path__ + "static/media/Ultimate-Pokedex-Screenshot.ce15184c.jpg";